module.exports = __webpack_public_path__ + "static/media/service-deposit.f361e33f.png";